export const dashboardJobHref = (
  routes: { dashboardJob?: string },
  jobId: string,
): string =>
  (routes.dashboardJob ?? "/dashboard/jobs/:id").replace(":id", jobId);
